import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';

export default function SearchBar() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    type: 'all',
    location: '',
    minPrice: '',
    maxPrice: '',
  });

  const { type, location, minPrice, maxPrice } = formData;

  function onChange(e) {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  }

  function onSubmit(e) {
    e.preventDefault();
    
    // Build query string
    const params = new URLSearchParams();
    if (type !== 'all') params.append('type', type);
    if (location) params.append('location', location);
    if (minPrice) params.append('minPrice', minPrice);
    if (maxPrice) params.append('maxPrice', maxPrice);

    navigate(`/search?${params.toString()}`);
  }

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 -mt-8 relative z-10 max-w-5xl mx-auto">
      <form onSubmit={onSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          {/* Property Type */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Property Type
            </label>
            <select
              id="type"
              value={type}
              onChange={onChange}
              className="w-full px-4 py-3 text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:border-blue-600 focus:outline-none"
            >
              <option value="all">All</option>
              <option value="rent">Rent</option>
              <option value="sale">Buy</option>
            </select>
          </div>

          {/* Location */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Location
            </label>
            <input
              type="text"
              id="location"
              value={location}
              onChange={onChange}
              placeholder="City or Area"
              className="w-full px-4 py-3 text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:border-blue-600 focus:outline-none"
            />
          </div>

          {/* Min Price */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Min Price (₹)
            </label>
            <input
              type="number"
              id="minPrice"
              value={minPrice}
              onChange={onChange}
              placeholder="Min"
              className="w-full px-4 py-3 text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:border-blue-600 focus:outline-none"
            />
          </div>

          {/* Max Price */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Max Price (₹)
            </label>
            <input
              type="number"
              id="maxPrice"
              value={maxPrice}
              onChange={onChange}
              placeholder="Max"
              className="w-full px-4 py-3 text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:border-blue-600 focus:outline-none"
            />
          </div>

          {/* Search Button */}
          <div className="flex items-end">
            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded transition duration-150 ease-in-out flex items-center justify-center gap-2"
            >
              <FaSearch />
              Search
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
